import { tokens } from '@fluentui/react-components'

interface Props {
  value: string           // ISO yyyy-mm-dd (nebo prázdný string)
  onChange: (iso: string) => void
  min?: string            // ISO yyyy-mm-dd — nejdřívější přípustné datum
  required?: boolean
  disabled?: boolean
}

/**
 * Nativní <input type="date"> stylovaný jako Fluent UI field.
 * Na iOS/Android otevře systémový picker, na desktopu prohlížečový kalendář.
 * Nahrazuje CzDateInput (IMask) všude, kde je potřeba univerzální kompatibilita.
 */
export function NativeDateInput({ value, onChange, min, required, disabled }: Props) {
  return (
    <input
      type="date"
      value={value}
      min={min}
      required={required}
      disabled={disabled}
      onChange={e => onChange(e.target.value)}
      style={{
        width: '100%',
        height: '32px',
        paddingLeft: '10px',
        paddingRight: '10px',
        border: `1px solid ${tokens.colorNeutralStroke1}`,
        borderRadius: tokens.borderRadiusMedium,
        fontFamily: tokens.fontFamilyBase,
        fontSize: tokens.fontSizeBase300,
        color: value ? tokens.colorNeutralForeground1 : tokens.colorNeutralForeground4,
        backgroundColor: disabled ? tokens.colorNeutralBackgroundDisabled : tokens.colorNeutralBackground1,
        boxSizing: 'border-box',
        outline: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        appearance: 'none' as any,
        WebkitAppearance: 'none',
      }}
    />
  )
}
